<template>
    <div class="gameplan">
      <ContentHeader path-set-type="append" :gameplan-nav="false" />
      <div class="content-wrapper">
        <div class="activity_new" v-loading="infoLoading">
          <div class="normal_box margin-top-20" v-if="Object.keys(themeBasic).length>0">
            <div class="item-info">
              <div class="pr_title">
                {{themeBasic.themeName}}
              </div>
              <div class="pr_detail">
                <div class="display-flex">
                  <div>活动PR：{{themeBasic.gpPrDTO&&themeBasic.gpPrDTO.prNumber}} - {{themeBasic.gpPrDTO&&themeBasic.gpPrDTO.prName}}</div> 
                  <div class="pr_brand">{{themeBasic.gpPrDTO&&themeBasic.gpPrDTO.brandName}}</div>
                </div>
                <div class="pr_date" v-show="isChangeDate">活动执行时间：
                  <DatePicker class="date-picker-style" ref="datePickerRef" valueFormat="timestamp" type="daterange" :readonly="false"></DatePicker>
                  &nbsp;&nbsp;&nbsp;
                  <div class="pr_date_btn pr_date_btn_red" @click="handleSelectDate">确定</div>
                  <div class="pr_date_btn pr_date_btn_write" @click="hideDatePicker">取消</div>
                </div>
                <div class="pr_date" v-show="!isChangeDate">活动执行时间：
                  <div>{{themeBasic.themeStartTime | parseTime("{y}-{m}-{d}")}} - {{themeBasic.themeEndTime | parseTime("{y}-{m}-{d}")}} </div>
                  &nbsp;&nbsp;&nbsp;
                  <div class="pr_date_btn pr_date_btn_red" @click="showDatePicker" v-if="themeBasic.themeStatus!=500&&isOwner()">修改日期</div>
                </div>
              </div>
            </div>
          </div>

          <div  v-for="(detail,index) of detailList" :key="detail[0].themeDetail.themeStyleCode">
            <ConfigItem  @handleSubmit="handleSubmit" :buToCity="buToCity" :assignAreaList="assignAreaList" :assignRegionList="assignRegionList"
              :igniteOptions="igniteOptions" :themeStyleName="themeStyleName[index]" :themeStyle="detail" :detailListLength="detailListLength"
              :channelName="(themeBasic.themeChannels[index]&&themeBasic.themeChannels[index].themeChannelEnName)||''" ref="configItemRef" :assignList="assignList"></ConfigItem>
          </div>

          <div class="normal_box margin-top-20">
            <div class="upload_section">
              <div class="upload_item">
                <div class="upload_item_title">执行手册</div>
                  <div v-if="themeBasic.manualFileUri" class="upload_item_btn" @click="openFile('manualFileUri')">查看附件</div>
                  <div v-else class="upload_item_btn btn_disabled">暂无附件</div>
                  <FileUpload
                    ref="manualFileIdRef"
                    :upload-param="{ filePath: 'temp' }"
                    :save-item = "manualFile"
                    show-type="text"
                    :showFileList="false"
                    @uploaded="getManualFileId"
                    @removed="clearManualFileId"
                    >
                  </FileUpload>
                  <div v-if="themeBasic.themeStatus!=500&&isOwner()" class="update_item_btn" @click="updateFile('manualFile')">更新附件</div>
              </div>
              <div class="upload_item">
                <div class="upload_item_title">促销员执行数据收集模板</div>
                  <div v-if="themeBasic.execTemplateUri" class="upload_item_btn" @click="openFile('execTemplateUri')">查看附件</div>
                  <div v-else class="upload_item_btn btn_disabled">暂无附件</div>
                  <FileUpload
                    ref="execTemplateIdRef"
                    :upload-param="{ filePath: 'temp' }"
                    :save-item = "execTemplate"
                    show-type="text"
                    :showFileList="false"
                    @uploaded="getExecTemplateId"
                    @removed="clearExecTemplateId"
                    >
                  </FileUpload>
                  <div v-if="themeBasic.themeStatus!=500&&isOwner()" class="update_item_btn" @click="updateFile('execTemplate')">更新附件</div>
              </div>
              <!-- <div class="upload_item" v-if="isOwner(themeBasic.themeOwnerCode)">
                <div class="upload_item_title">推送活动需求</div>
                <div class="upload_item_btn" @click="handleSOW(themeId)">推送活动需求</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  <script>
  import gameplanApi from "@/api/gameplan";
  import FileUpload from './components/file-upload'
  import { mapGetters } from 'vuex'
  import { commonUtils } from '@/utils/common'
  import ContentHeader from "@/components/content-header";
  import DatePicker from "./components/date-picker";
  import ConfigItem from './components/config-info.vue'
  export default {
    components: {
      ContentHeader,
      ConfigItem,
      FileUpload,
      DatePicker
    },
    data() {
      return {
        employeeLevel: '',
        themeTime: [],
        applyTime: [],
        fullConfig: [],
        info:'',
        editRules: {
          themeName: [
            { required: true, message: "请输入活动名称", trigger: "blur" },
          ],
          themeChannelNames: [
            { required: true, message: "请输入选择活动渠道", trigger: "blur" },
          ],
        },
        themeChannelForm: [],
        themeChannelCodes: [],
        themeChannelNames: [],
        detailList: [],
        igniteOptions: {},
        themeBasic: {
          // applyEndTime: "2022-10-10T16:00:00.000Z",
          // applyStartTime: "2022-09-30T16:00:00.000Z",
          // execTemplateId: "222",
          // manualFileId: "111",
          // prNumber: "C2022",
          // themeChannelCodes: ["01"],
          // themeEndTime: "2022-10-10T16:00:00.000Z",
          // themeName: "",
          // themeStartTime: "",
        },
        themeStyleName:[],
        activeName:'',
        assignAreaList:[],
        assignRegionList:[],
        submitList:[],
        detailListLength:0,
        buToCity:0,
        submitDetailList:[],
        assignList:[],
        themeInfo:{},
        isSubmit:false,
        execTemplateUri:'',
        manualFileUri:'',
        infoLoading:false,
        manualFile: [],
        execTemplate:[],
        isChangeDate:false
        //themeChannelNames:
      };
    },
    computed: {
      ...mapGetters(['userInfo']),
    },
    created() {
      this.getGameplanConfigFull()
      this.employeeLevel = this.userInfo.employeeLevel
      this.getGameplanConfigIgniteOptions()
      this.themeId = this.$route.query.themeId
    },
    methods: {
      async getGameplanThemeInfo() {
        this.infoLoading = true
        let params = {
          themeId:this.$route.query.themeId
        }
        const { data } = await gameplanApi.getGameplanThemeInfo(params);
        if (data.resultCode === "0") {
          this.themeBasic = data.resultData?.themeInfo.themeBasic || []
          this.detailListLength = data.resultData.themeInfo.detailList.length
          let list = data.resultData?.themeInfo.detailList || [];
          this.themeId  = this.themeBasic
          // 按照相同的渠道拆分为detailList[]
          if(this.employeeLevel>=60&&this.employeeLevel<90){
            this.buToCity = this.themeBasic.buToCity
          }
          for(let i = 0;i<list.length;i++){
            let item  = list[i]
            let index = this.themeChannelCodes.indexOf(item.themeDetail.themeChannelCode)
            if(index!==-1){
              this.detailList[index].push(item)
              if(this.themeStyleName[index].indexOf(item.themeDetail.themeStyleName)===-1){
                this.themeStyleName[index].push(item.themeDetail.themeStyleName)
              }
            }else{
              this.themeChannelCodes.push(item.themeDetail.themeChannelCode)
              let data = [item]
              let item_themeStyleName = [item.themeDetail.themeStyleName]
              this.detailList.push(data)
              this.themeStyleName.push(item_themeStyleName)
            }
          }
        }
        this.infoLoading = false
      },
      async getGameplanConfigIgniteOptions() {
        const { data } = await gameplanApi.getGameplanConfigIgniteOptions();
        if (data.resultCode === "0") {
          this.igniteOptions = data.resultData?.igniteOptions || {};
        }
      },
      async getGameplanConfigFull() {
        const { data } = await gameplanApi.getGameplanConfigFull();
        if (data.resultCode === "0") {
          this.assignAreaList = data.resultData?.assignAreaList || []
          this.assignRegionList = data.resultData?.assignRegionList || []
          if(this.employeeLevel<60){
            this.buToCity = 0
            this.assignList = this.assignAreaList // Object.assign({},this.assignAreaList) 
          }
        }
        this.getGameplanThemeInfo()
      },
      async getGameplanThemeSubmit(data) {
        const res = await gameplanApi.getGameplanThemeSubmit(data);
        if (res.data.resultCode === "0") {
          this.$message.success("提交成功！")
          this.$router.push({path:'/gameplan/activity-management/01'})
        }
      },
      isOwner(){
        return this.userInfo.employeeCode===this.themeBasic.themeOwnerCode
      },
      openFile(type){
        if(type === 'execTemplateUri'){
          window.open(commonUtils.getImageUrl(this.themeBasic.execTemplateUri))
        }else if(type === 'manualFileUri'){
          window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
        }
      },
      // handleSOW(){
      //   this.$confirm('是否要推送活动需求', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     confirmButtonClass: 'btn-red',
      //     type: 'warning'
      //   }).then(async() => {
      //     const { data } = await gameplanApi.gameplanThemeDownload(this.$route.query.themeId);
      //       if (data.resultCode === "0") {
      //         this.$alert('推送成功', '提示', {
      //           confirmButtonText: '确定',
      //         });
      //       }
      //   }).catch(() => {
      //   });
      // },
              // 上传文件
      getManualFileId (file) {
        let params = {
          themeId:this.$route.query.themeId,
          manualFileId:file.fileId
        }
        this.getGameplanThemeUpdate(params)
      },
      getExecTemplateId (file) {
        let params = {
          themeId:this.$route.query.themeId,
          execTemplateId:file.fileId
        }
        this.getGameplanThemeUpdate(params)
      },
      async getGameplanThemeUpdate(params){
        const { data } = await gameplanApi.getGameplanThemeUpdate(params);
        if (data.resultCode === "0") {
          this.$message.success("更新成功！")
          window.location.reload()
        }
      },
      // 删除文件
      clearManualFileId (file) {
        this.errorList = []
      },
      clearExecTemplateId (file) {
        this.errorList = []
      },
      updateFile(type){
        this.$confirm('是否要更新附件？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(() => {
          if(type=='manualFile'){
            this.$refs['manualFileIdRef'].$refs['fileUploadControl'].$refs['upload-inner'].handleClick()
          }else if(type=='execTemplate'){
            this.$refs['execTemplateIdRef'].$refs['fileUploadControl'].$refs['upload-inner'].handleClick()
          }
          // this.$refs['manualFileIdRef'].$refs['upload-inner'].handleClick()
          // const { data } = await gameplanApi.gameplanThemeDownload(this.$route.query.themeId);
          //   if (data.resultCode === "0") {
          //     this.$alert('推送成功', '提示', {
          //       confirmButtonText: '确定',
          //     });
          //   }
        }).catch(() => {
        });
      },
      handleSubmit(detailItem,isSubmit) {
        if(isSubmit){
          this.submitList.push(detailItem)
        }
      },
      getChannelName(){
        let result = ''
        for(let item of this.themeBasic.themeChannels){
          result += item.themeChannelEnName+'、'
        }
        return result.substr(0, result.length - 1); 
      },
      showDatePicker(){
        this.isChangeDate = true
        this.$refs.datePickerRef.showDatePicker()
      },
      hideDatePicker(){
        this.isChangeDate = false
      },
      handleSelectDate(){
        let dateList = this.$refs.datePickerRef.dateList
        if(!dateList||dateList.length!==2){
          this.$alert('请选择活动执行时间', '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-red',
            type: 'warning'
          })
          return
        }
        this.$confirm('是否修改活动执行时间？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(async () => {
          let params = {
            themeStartTime:dateList[0],
            themeEndTime:dateList[1],
            themeId:this.themeBasic.themeId
          }
          const { data } = await gameplanApi.getGameplanThemeUpdateDate(params);
          if (data.resultCode === "0") {
            this.$message.success("修改成功")
            this.isChangeDate = false
            this.getGameplanConfigFull()
          }
        }).catch(() => {
          this.isChangeDate = false
        });
      }
    },
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep.el-radio {
    margin-right: 60px;
  
    .el-radio__input {
      display: inline-block;
      padding-right: 5px;
  
      &.is-checked .el-radio__inner {
        border-color: $base-red;
        background: $base-red;
      }
  
      &.is-checked+.el-radio__label {
        color: #101010;
      }
    }
  }
  
  ::v-deep .activity_new .el-form-item {
    min-width: 48%;
    margin-bottom: 12px;
  
    .el-form-item__label {
      color: black;
    }
  }
  .margin-top-20{
    margin-top: 40px;
    min-height: 75px;
  }
  .content-wrapper {
    margin-top: -50px;
  
    .activity_new {
      position: relative;
  
      .activity-new-card {
        padding: 20px 10px 20px 0px;
        background-color: #ffffff;
        color: #101010;
        border-radius: 10px;
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-bold;
        display: flex;
        justify-content: flex-start;
  
        .po_config_btn {
          position: absolute;
          right: 0;
          top: -25px;
          width: 120px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          background-color: #539efe;
          color: #ffffff;
          font-size: 14px;
          text-align: center;
          font-family: Roboto;
        }
      }
  
      .activity_channel_checkbox {
        margin-top: 0px;
      }
  
      .activity_channel_checkbox_label {
        text-align: center;
        position: relative;
        top: 15px;
        line-height: 15px;
      }
    }
  }
  .item-info{
    //width: 100%;
     margin: 0 10px;
    .pr_title{
      font-size: $font-18;
      font-weight: 600;
    }
    .pr_detail{
      //width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .pr_date{
        display: flex;
        justify-content:flex-end;
        color: grey;
        min-width: 486px;
        .pr_date_btn{  
          cursor: pointer;
          font-size: 14px;
          margin: -6px 5px 0 0;
          line-height: 30px;
          text-align: center;
          vertical-align: middle;
          border-radius: 5px;
        }
        .pr_date_btn_red {
          height: 30px;
          padding: 0 10px;
          color: white;
          background-color: rgb(204, 0, 0);
        }
        .pr_date_btn_write{
          height: 28px;
          padding: 0 9px;
          color: rgb(204, 0, 0);
          border: solid 1px rgb(204, 0, 0);;
          background-color: rgb(255, 255, 255);
        }
      }
      .pr_brand{
        font-size: 12px;
        height: 12px;
        padding: 3px 5px;
        color: rgb(51, 180, 255);
        border: 1px solid rgb(51, 180, 255);
        border-radius: 4px;
        margin-left: 20px;
        line-height: 12px;
        word-break: keep-all;
      }
    }
    .display-flex{
      display: flex;
      //text-align: center;
      line-height: 17px;
    }
  }

  
  .activity_form{
    margin: 0px 0 30px 40px;
    font-weight: 600;
    font-size: 15px;
    height: 30px;
  }
  .activity_form_detail{
    margin-left: 100px;
  }
  .activity_form_box{
    margin-bottom:20px;
    height: 25px;
  }
  
  .tab_box {
    margin-top: 20px;
  
    .tab_item_box {
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      border-top-right-radius: 8px;
  
      .tab_item_context {
        height: 100%;
        width: calc(100% - 40px);
        padding: 20px;
        font-size: 15px;
      }
    }
  }
  .item_title{
    display: inline-block;
    width: 200px;
    font-weight: 600;
  }
  .item_detail{
    margin: 20px 5px ;
  }
  
  
  .btn_section {
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 15px;
    text-align: center;
    margin-top: 60px;
  
    .normal_btn {
      width: 100px;
      padding: 10px 0;
      border-radius: 5px;
      cursor: pointer;
    }
  
    .btn_bg_white {
      border: 1px solid rgb(204, 0, 0);
      color: rgb(204, 0, 0);
      margin-right: 100px;
    }
  
    .btn_bg_red {
      color: white;
      background-color: rgb(204, 0, 0);
      border: 1px solid rgb(204, 0, 0);
    }
  }

  .upload_section {
  margin: 0px 0 0 15px;
  font-size: 12px;
  .upload_item {
    display: flex;
    margin-left: 30px;
  }

  .upload_item_title {
    width: 220px;
    font-size: 14px;
    font-weight: 600;
    padding: 20px 10px;
  }

  .upload_item_btn {
    cursor: pointer;
    margin-top: 13px;
    height: 30px;
    line-height: 30px;
    width: 100px;
    border-radius: 5px;
    text-align: center;
    vertical-align: middle;
    color: white;
    background-color: rgb(204, 0, 0);
  }
}
.update_item_btn{
 margin-left: 20px;
 cursor: pointer;
  margin-top: 13px;
  height: 28px;
  line-height: 30px;
  width: 98px;
  border-radius: 5px;
  border: 1px solid rgb(204, 0, 0);
  text-align: center;
  vertical-align: middle;
  color: rgb(204, 0, 0);
  background-color: rgb(255, 255, 255);
}
.btn_disabled{
  background-color: $base-grey !important;
}
.date-picker-style{
  margin-top: -10px;
}
  </style>